export const theme = {
    colors: {
        primary: '#e50914',
        secondary: '#564d4d',
        dark: '#141414',
        darkGray: '#2f2f2f',
        gray: '#808080',
        lightGray: '#e5e5e5',
        white: '#ffffff',
        text: '#ffffff',
        textSecondary: '#b3b3b3',
        background: '#141414',
        surface: '#2f2f2f',
        border: '#808080',
        rating: '#ffd700',
        error: '#d32f2f',
        success: '#4caf50',
    },

    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
        xxl: '48px',
    },

    borderRadius: {
        sm: '4px',
        md: '8px',
        lg: '12px',
        xl: '16px',
    },

    shadows: {
        sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
        md: '0 4px 8px rgba(0, 0, 0, 0.15)',
        lg: '0 8px 16px rgba(0, 0, 0, 0.2)',
        xl: '0 12px 24px rgba(0, 0, 0, 0.25)',
    },

    transitions: {
        fast: '0.2s ease',
        normal: '0.3s ease',
        slow: '0.5s ease',
    },

    breakpoints: {
        mobile: '480px',
        tablet: '768px',
        desktop: '1024px',
        wide: '1440px',
    },

    fontSizes: {
        xs: '12px',
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '24px',
        xxl: '32px',
        xxxl: '48px',
    },

    fontWeights: {
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
};
